function isCommandChord(event: KeyboardEvent, key: string) {
  if (event.repeat || event.altKey || event.shiftKey) return false;
  if (!(event.metaKey || event.ctrlKey)) return false;
  return event.key.toLowerCase() === key;
}

export function isCommandPaletteHotkey(event: KeyboardEvent) {
  return isCommandChord(event, "k");
}

/** Browsers reserve Cmd/Ctrl-N for a new window, so this only reaches the desktop app. */
export function isCreateMenuHotkey(event: KeyboardEvent) {
  return isCommandChord(event, "n");
}

/** True for text inputs, textareas and contenteditable hosts, where Cmd/Ctrl-B may mean bold. */
function isEditableTarget(target: EventTarget | null) {
  if (!target || typeof target !== "object") return false;
  const el = target as { tagName?: string; isContentEditable?: boolean };
  if (el.isContentEditable) return true;
  const tag = el.tagName?.toUpperCase();
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}

/**
 * Cmd/Ctrl-B collapses or expands the sidebar, as in Claude Desktop.
 * Ignored inside editable fields; Cmd/Ctrl-K stays global on purpose, like other command palettes.
 */
export function isSidebarToggleHotkey(event: KeyboardEvent) {
  if (isEditableTarget(event.target)) return false;
  return isCommandChord(event, "b");
}
